import { Component, OnInit, ViewChild } from '@angular/core'
import { BsModalRef } from 'ngx-bootstrap/modal'
import { Subject } from 'rxjs'
import {
  IFeeSchedule,
  ProcedureCodeFeeODataService,
  RevenueCodeFeeODataService
} from '@exchange/domain/.'
import { GridWrapperComponent } from 'common-components'

@Component({
  selector: 'app-entity-group-fee-schedule-codes-modal',
  templateUrl: './entity-group-fee-schedule-codes-modal.component.html',
  standalone: false
})
export class EntityGroupFeeScheduleCodesModalComponent implements OnInit {
  @ViewChild('feeScheduleProcCodesGrid', { static: true })
  feeScheduleProcCodesGrid: GridWrapperComponent
  @ViewChild('feeScheduleRevCodesGrid', { static: true })
  feeScheduleRevCodesGrid: GridWrapperComponent
  feeSchedule: IFeeSchedule
  title = ''
  message = ''
  onClose: Subject<boolean>

  constructor(
    public modalRef: BsModalRef,
    private procedureCodeFeeService: ProcedureCodeFeeODataService,
    private revenueCodeFeeService: RevenueCodeFeeODataService
  ) {}

  public ngOnInit(): void {
    this.onClose = new Subject<boolean>()
    this.initProcCodesGrid()
    this.initRevCodesGrid()
  }

  confirm(): void {
    this.modalRef.hide()
    this.onClose.next(false)
    this.onClose.complete()
  }

  initProcCodesGrid() {
    this.feeScheduleProcCodesGrid.defaultFilter = `FeeScheduleId eq ${this.feeSchedule.Id}`
    this.feeScheduleProcCodesGrid.gridOptions.columnDefs = [
      {
        headerName: 'Code',
        field: 'Code',
        width: 75,
        cellRenderer: GridWrapperComponent.TooltipRenderer(),
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Modifier',
        field: 'Modifier',
        width: 100,
        editable: true,
        cellRenderer: GridWrapperComponent.TooltipRenderer(),
        filter: 'agTextColumnFilter',
        cellStyle: { 'background-color': 'lightBlue' }
      },
      {
        headerName: 'Amount',
        field: 'Amount',
        width: 100,
        editable: true,
        cellRenderer: GridWrapperComponent.CurrencyRenderer(),
        filter: 'agNumberColumnFilter',
        cellStyle: { 'background-color': 'lightBlue' }
      },
      {
        headerName: 'Description',
        field: 'Description',
        width: 200,
        cellRenderer: GridWrapperComponent.TooltipRenderer(),
        filter: 'agTextColumnFilter'
      }
    ]
    this.feeScheduleProcCodesGrid.odata = this.procedureCodeFeeService
  }

  initRevCodesGrid() {
    this.feeScheduleRevCodesGrid.defaultFilter = `FeeScheduleId eq ${this.feeSchedule.Id}`
    this.feeScheduleRevCodesGrid.gridOptions.columnDefs = [
      {
        headerName: 'Code',
        field: 'Code',
        width: 75,
        cellRenderer: GridWrapperComponent.TooltipRenderer(),
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep' }
      },
      {
        headerName: 'Amount',
        field: 'Amount',
        width: 100,
        editable: true,
        cellRenderer: GridWrapperComponent.CurrencyRenderer(),
        filter: 'agNumberColumnFilter',
        filterParams: { newRowsAction: 'keep' },
        cellStyle: { 'background-color': 'lightBlue' }
      },
      {
        headerName: 'Description',
        field: 'Description',
        width: 200,
        cellRenderer: GridWrapperComponent.TooltipRenderer(),
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep' }
      }
    ]
    this.feeScheduleRevCodesGrid.odata = this.revenueCodeFeeService
    this.feeScheduleRevCodesGrid.gridOptions.suppressColumnVirtualisation = true
  }

  revCodesSelect() {
    setTimeout(() => {
      this.feeScheduleRevCodesGrid.api.autoSizeAllColumns()
    }, 0)
  }
}
